// About page photo config. Drop image files into /public/assets/about-photos/
// and add the path here.
//
// The About page grid renders whatever is in this array (up to 5 slots).
// If fewer than 5 photos are provided, remaining slots render as dark-green
// editorial placeholders. Empty array = full placeholder grid.
export const aboutPhotos = [
  "/assets/about-photos/photo-1.jpg", // Saudi Event Show — hero tile (large)
  "/assets/about-photos/photo-2.jpg", // Pakistan Embassy — 70 Years event
  "/assets/about-photos/photo-3.jpg", // DMZ Toronto — Why KSA
  "/assets/about-photos/photo-4.jpg", // Astrolabs — Where to Raise (UAE/KSA)
  "/assets/about-photos/photo-5.jpg", // GREAT Britain — Understanding the Business Environment
];
